// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max"; 
 
//分页查询付款周期记录
export  function getListApi(params:any) {
  return request<API.ResponseData>("/wrs/resiBatchRecord/pageList", {
    method: "POST", 
    data: params,
  });
}  
//根据批次ID查询每日汇总历史记录明细
export  function listByBatchIdApi(params:any) {
  return request<API.ResponseData>("/wrs/resiReportDailySummaryRecord/listByBatchId", {
    method: "POST", 
    data: params,
  });
}  
//根据批次ID查询每日汇总历史记录明细
export  function reportedDetailApi(params:any) {
  return request<API.ResponseData>("/wrs/resiReportRawData/reportedDetail", {
    method: "GET", 
    params: params,
  });
}   
//批量导出数据
export function exportListApi (params: any) {
  return request<API.ResponseData>(`/wrs/resiBatchRecord/export`, {
    method: "POST",
    data:params,
    responseType: 'blob'
  });
} 
  
//批量导出数据
export function exportDetailListApi (params: any) {
  return request<API.ResponseData>(`/wrs/resiReportDailySummaryRecord/export`, {
    method: "POST",
    data:params,
    responseType: 'blob'
  });
} 


 //查询近一个月上报记录
export function lastMonthReportApi (params: any) {
  return request<API.ResponseData>(`/wrs/resiBatchRecord/lastMonthGenerateReport`, {
    method: "GET", 
    params: params,
  });
} 
 //查询近一个月上报记录
export function todayReportStatusApi (params: any) {
  return request<API.ResponseData>(`/wrs/resiBatchRecord/todayReportStatus`, {
    method: "GET", 
    params: params,
  });
}  
 //按生成批次查询上报历史批次
export function reportHistoryByGenerateBatchIdApi (params: any) {
  return request<API.ResponseData>(`/wrs/resiBatchRecord/reportHistoryByGenerateBatchId`, {
    method: "GET", 
    params: params,
  });
} 
